module.exports = __webpack_public_path__ + "img/reply-all.dd475dbb.svg";